import APIclient from "API/Client";

export const getSmartCSVTemplate = () => {
  return APIclient.getData(`/ms/b2b-accounting/v1/partner/template`);
};

export const downloadSmartCSVTemplate = (payload) => {
  return APIclient.postData(`/ms/b2b-accounting/v1/partner/template/generate`, payload);
};
